import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ErrorModal from "../../components/Error/Error";
import Loading from "../../components/Loading/Loading";
import PhotoGallery from "../../components/PhotoGallery/PhotoGallery";
import PhotoZoom from "../../components/PhotoZoom/PhotoZoom";
import { useData } from "../../context/DataProvider";
import { richTextRenderer } from "../../utils/commonUtil";
import styles from "./ProjectDetailPage.module.scss";

/* Mock data
const data: IProjectsPageItem[] = [
  {
    baslik:
      "Lorem Ipsum Dolor Sit Amet Consectetur Adipiscing Elit Sed Do Eiusmod",
    aciklama: "deneme",
    projeYer: "deneme",
    projeYil: "2025-01-06T09:56:11.0345586+03:00",
    projeIsbirlik: "deneme",
    projeEkip: "deneme",
    insaatAlan: "deneme",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel: "/assets/projectYatay.png",
    temaTipId: "08eb1060-e585-4894-c496-08dd267b32b1",
    projeFotolar: [
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/b6c07b08-a608-4ce3-9907-fa95c4978ba7.jpg",
        dosyaTip: "image/jpeg",
        sira: 1,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "d7ffbc3e-b0f5-42b4-54d0-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9059361",
        updatedDate: null,
      },
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/60d5be3a-90e7-4adc-aebc-3935fcb904a0.jpg",
        dosyaTip: "image/jpeg",
        sira: 2,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
    ],
    temaTipleriAdi: "tema2",
    id: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
    status: 1,
    createdDate: "2025-01-06T09:56:11.0345586+03:00",
    updatedDate: null,
  },
  {
    baslik:
      "2Lorem Ipsum Dolor Sit Amet Consectetur Adipiscing Elit Sed Do Eiusmod",
    aciklama: "deneme",
    projeYer: "deneme",
    projeYil: "2025-01-06T09:56:11.0345586+03:00",
    projeIsbirlik: "deneme",
    projeEkip: "deneme",
    insaatAlan: "deneme",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel: "/assets/projectYatay.png",
    temaTipId: "08eb1060-e585-4894-c496-08dd267b32b1",
    projeFotolar: [
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/b6c07b08-a608-4ce3-9907-fa95c4978ba7.jpg",
        dosyaTip: "image/jpeg",
        sira: 1,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "d7ffbc3e-b0f5-42b4-54d0-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9059361",
        updatedDate: null,
      },
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/60d5be3a-90e7-4adc-aebc-3935fcb904a0.jpg",
        dosyaTip: "image/jpeg",
        sira: 2,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
    ],
    temaTipleriAdi: "tema2",
    id: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
    status: 1,
    createdDate: "2025-01-06T09:56:11.0345586+03:00",
    updatedDate: null,
  },
  {
    baslik:
      "3Lorem Ipsum Dolor Sit Amet Consectetur Adipiscing Elit Sed Do Eiusmod",
    aciklama: "deneme",
    projeYer: "deneme",
    projeYil: "2025-01-06T09:56:11.0345586+03:00",
    projeIsbirlik: "deneme",
    projeEkip: "deneme",
    insaatAlan: "deneme",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel: "/assets/projectYatay.png",
    temaTipId: "08eb1060-e585-4894-c496-08dd267b32b1",
    projeFotolar: [
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/b6c07b08-a608-4ce3-9907-fa95c4978ba7.jpg",
        dosyaTip: "image/jpeg",
        sira: 1,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "d7ffbc3e-b0f5-42b4-54d0-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9059361",
        updatedDate: null,
      },
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/60d5be3a-90e7-4adc-aebc-3935fcb904a0.jpg",
        dosyaTip: "image/jpeg",
        sira: 2,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
    ],
    temaTipleriAdi: "tema2",
    id: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
    status: 1,
    createdDate: "2025-01-06T09:56:11.0345586+03:00",
    updatedDate: null,
  },
  {
    baslik: "deneme2",
    aciklama: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.

Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.

Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.`,
    projeYer: "deneme2",
    projeYil: "2024-09-06T09:56:11.0345586+03:00",
    projeIsbirlik: "deneme2",
    projeEkip: "deneme2",
    insaatAlan: "deneme2",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel: "/assets/projectYatay.png",
    temaTipId: "08eb1060-e585-4894-c496-08dd267b32b1",
    projeFotolar: [
      {
        dosya: "/assets/projectImage.png",
        dosyaTip: "image/jpeg",
        sira: 1,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "d7ffbc3e-b0f5-42b4-54d0-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9059361",
        updatedDate: null,
      },
      {
        dosya: "/assets/projectImage.png",
        dosyaTip: "image/jpeg",
        sira: 2,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
      {
        dosya: "/assets/projectImage.png",
        dosyaTip: "image/jpeg",
        sira: 3,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
      {
        dosya: "/assets/projectImage.png",
        dosyaTip: "image/jpeg",
        sira: 4,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
      {
        dosya: "/assets/projectImage.png",
        dosyaTip: "image/jpeg",
        sira: 5,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
      {
        dosya: "/assets/projectImage.png",
        dosyaTip: "image/jpeg",
        sira: 6,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
      {
        dosya: "/assets/projectImage.png",
        dosyaTip: "image/jpeg",
        sira: 7,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
      {
        dosya: "/assets/projectImage.png",
        dosyaTip: "image/jpeg",
        sira: 8,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
      {
        dosya: "/assets/projectImage.png",
        dosyaTip: "image/jpeg",
        sira: 9,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
      {
        dosya: "/assets/projectImage.png",
        dosyaTip: "image/jpeg",
        sira: 10,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
    ],
    temaTipleriAdi: "tema2",
    id: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
    status: 1,
    createdDate: "2024-09-06T09:56:11.0345586+03:00",
    updatedDate: null,
  },
  {
    baslik: "deneme3",
    aciklama: "deneme2",
    projeYer: "deneme2",
    projeYil: "2024-09-06T09:56:11.0345586+03:00",
    projeIsbirlik: "deneme2",
    projeEkip: "deneme2",
    insaatAlan: "deneme2",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel: "/assets/projectYatay.png",
    temaTipId: "08eb1060-e585-4894-c496-08dd267b32b1",
    projeFotolar: [
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/b6c07b08-a608-4ce3-9907-fa95c4978ba7.jpg",
        dosyaTip: "image/jpeg",
        sira: 1,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "d7ffbc3e-b0f5-42b4-54d0-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9059361",
        updatedDate: null,
      },
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/60d5be3a-90e7-4adc-aebc-3935fcb904a0.jpg",
        dosyaTip: "image/jpeg",
        sira: 2,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
    ],
    temaTipleriAdi: "tema2",
    id: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
    status: 1,
    createdDate: "2024-09-06T09:56:11.0345586+03:00",
    updatedDate: null,
  },
  {
    baslik: "deneme4",
    aciklama: "deneme2",
    projeYer: "deneme2",
    projeYil: "2024-09-06T09:56:11.0345586+03:00",
    projeIsbirlik: "deneme2",
    projeEkip: "deneme2",
    insaatAlan: "deneme2",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel: "/assets/projectYatay.png",
    temaTipId: "08eb1060-e585-4894-c496-08dd267b32b1",
    projeFotolar: [
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/b6c07b08-a608-4ce3-9907-fa95c4978ba7.jpg",
        dosyaTip: "image/jpeg",
        sira: 1,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "d7ffbc3e-b0f5-42b4-54d0-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9059361",
        updatedDate: null,
      },
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/60d5be3a-90e7-4adc-aebc-3935fcb904a0.jpg",
        dosyaTip: "image/jpeg",
        sira: 2,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
    ],
    temaTipleriAdi: "tema2",
    id: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
    status: 1,
    createdDate: "2024-09-06T09:56:11.0345586+03:00",
    updatedDate: null,
  },
  {
    baslik: "deneme5",
    aciklama: "deneme2",
    projeYer: "deneme2",
    projeYil: "2024-09-06T09:56:11.0345586+03:00",
    projeIsbirlik: "deneme2",
    projeEkip: "deneme2",
    insaatAlan: "deneme2",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel: "/assets/projectYatay.png",
    temaTipId: "08eb1060-e585-4894-c496-08dd267b32b1",
    projeFotolar: [
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/b6c07b08-a608-4ce3-9907-fa95c4978ba7.jpg",
        dosyaTip: "image/jpeg",
        sira: 1,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "d7ffbc3e-b0f5-42b4-54d0-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9059361",
        updatedDate: null,
      },
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/60d5be3a-90e7-4adc-aebc-3935fcb904a0.jpg",
        dosyaTip: "image/jpeg",
        sira: 2,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
    ],
    temaTipleriAdi: "tema2",
    id: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
    status: 1,
    createdDate: "2024-09-06T09:56:11.0345586+03:00",
    updatedDate: null,
  },
];
*/

const ProjectDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [showZoom, setShowZoom] = useState(false);
  const { projeler: data, isLoading, error } = useData();

  if (isLoading) return <Loading />;
  if (error) return <ErrorModal message={error.message} />;

  // URL'deki başlığa göre projeyi bul
  const project = data.find(
    (item) => item.baslik === decodeURIComponent(id || "")
  );

  if (!project) {
    return <div>Proje bulunamadı</div>;
  }

  return (
    <div className={styles.container}>
      <div className={styles.heroImage}>
        <img
          src={project.yatayGorsel}
          alt={project.baslik}
          onClick={() => setShowZoom(true)}
        />
        {showZoom && (
          <PhotoZoom
            src={project.yatayGorsel}
            onClose={() => setShowZoom(false)}
          />
        )}
      </div>

      <div className={styles.content}>
        <h1 className={styles.title}>{project.baslik}</h1>

        <div className={styles.description}>
          <div>{richTextRenderer(project.aciklama)}</div>
        </div>

        <div className={styles.details}>
          <div className={styles.detailItem}>
            <p className={styles.label}>Proje Teması :</p>
            <p
              className={`${styles.value} ${styles.theme}`}
              onClick={() => {
                navigate(`/temaDetay/${project.temaTipleriAdi}`);
              }}
            >
              {project.temaTipleriAdi}
            </p>
          </div>

          <div className={styles.detailItem}>
            <p className={styles.label}>Proje Yeri :</p>
            <p className={styles.value}>{project.projeYer}</p>
          </div>

          <div className={styles.detailItem}>
            <p className={styles.label}>Proje Yılı :</p>
            <p className={styles.value}>
              {new Date(project.projeYil).getFullYear()}
            </p>
          </div>

          <div className={styles.detailItem}>
            <p className={styles.label}>Proje İşbirliği :</p>
            <p className={styles.value}>
              {richTextRenderer(project.projeIsbirlik)}
            </p>
          </div>

          <div className={styles.detailItem}>
            <p className={styles.label}>Proje Ekibi :</p>
            <p className={styles.value}>
              {richTextRenderer(project.projeEkip)}
            </p>
          </div>

          <div className={styles.detailItem}>
            <p className={styles.label}>Proje İnşaat Alanı :</p>
            <p className={styles.value}>{project.insaatAlan}</p>
          </div>
        </div>

        <PhotoGallery photos={project.projeFotolar} />
      </div>
    </div>
  );
};

export default ProjectDetailPage;
